/* eslint-disable jsx-a11y/anchor-has-content */
import '@fpsm/cxy-tokens/tokens.css';

import { useState } from 'react';
import { type MobileBottomNavItem } from '@cx-web/api-clients/nav-api/types';
import { navItemType } from '@cx-web/domain-types';
import { useNavData } from '@cx-web/ui-shell/nav-data-context';
import { getRepubMetaFromRepub } from '@cx-web/utils';

import { type Repub } from '@cx-modules/constants';

import AllSportsButton from './components/AllSportsButton';
import AllSportsMenu from './components/AllSportsMenu';
import BetslipToggle from './components/BetslipToggle';
import NavLink from './components/NavLink';
import styles from './MobileBottomNav.module.css';

interface MobileBottomNavProps {
  pathname: string;
  repub: Repub;
  serverUrl?: string;
}

export const MobileBottomNav = ({ pathname, repub, serverUrl }: MobileBottomNavProps) => {
  const mobileBottomNavData = useNavData().mobileBottomNav;
  const filteredMobileBottomNavData = mobileBottomNavData.filter(item => item.type !== 'BETSLIP');
  const [allSportsOpen, setAllSportsOpen] = useState(false);
  const isIT = getRepubMetaFromRepub(repub).repubIs.IT;

  const shouldShowBetslip = !!mobileBottomNavData.find(link => link.type === 'BETSLIP');

  return (
    <nav
      aria-label="Mobile Bottom Navigation Bar"
      className={`${styles.mobileBottomNavContainer}`}
      data-testid="mobile-bottom-nav-v2"
    >
      <ul className={`${styles.bottomNavigation} ${allSportsOpen ? styles.open : ''}`}>
        {filteredMobileBottomNavData.map((item: MobileBottomNavItem) => {
          const isAllSports = item.type === navItemType.ALL_SPORTS_EXPANDABLE;

          return isAllSports ? (
            <AllSportsButton
              allSportsOpen={allSportsOpen}
              isIT={isIT}
              key="AllSportsButton"
              setAllSportsOpen={setAllSportsOpen}
            />
          ) : (
            <NavLink item={item} key={item.name} pathname={pathname} serverUrl={serverUrl} />
          );
        })}
        {shouldShowBetslip && <BetslipToggle />}
      </ul>
      <AllSportsMenu allSportsOpen={allSportsOpen} setAllSportsOpen={setAllSportsOpen} />
      <div className={`${styles.backdrop} ${allSportsOpen ? '' : styles.off}`} />
    </nav>
  );
};
